// extracted by mini-css-extract-plugin
export default {"background":"CdoY3","number":"i6jgR","numberBorder":"DOTp5","skeleton":"BR27i","ticket":"Vg8Ur"};